import { usePageTitle } from "@/hooks/usePageTitle";
import { useTranslation } from "react-i18next";
import { ResourceListLayout } from "@/layouts/ResourceListLayout";
import { TenantsActions } from "@/resources-def/tenants-comp";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";

const RESOURCE = 'tenants';

export const TenantListPage = ({ children }) => {
  usePageTitle("Tenants");
  const { t } = useTranslation();

  const navigate = useResourceNavigate();

  const columns = [
    { title: t("fields.name"), dataIndex: "name", render: (text, record) => <a onClick={(e) => navigate({ resource: RESOURCE, key: record.name, action: 'enter'}) }>{text}</a> },
    { title: t("tenants.fields.usersCount"), dataIndex: "users" },
    { title: t("tenants.fields.subscription"), dataIndex: "subscription" },
    { title: t("tenants.fields.instanceCount"), dataIndex: "instances" },
    { title: t("tenants.fields.currentInstanceCount"), dataIndex: "curr_instances" },
    { title: t("tenants.fields.createdBy"), dataIndex: "createdBy" },
  ];

  return (
    <ResourceListLayout
      resource={RESOURCE}
      actions={TenantsActions}
      columns={columns}
    >
    </ResourceListLayout>
  );
};
